// Turns a poster into a player on click, and never before.
//
// Delegated from the document so a block added in the theme editor works
// without re-running anything, and guarded so the listener is attached once no
// matter how many posters the page carries.
(function () {
  if (window.__pruvitMediaPoster) return;
  window.__pruvitMediaPoster = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pruvit-media-play]');
    if (!button) return;

    var wrapper = button.parentNode;
    var embed = button.getAttribute('data-embed');
    var template = wrapper.querySelector('template[data-pruvit-media-video]');
    var player;

    if (template) {
      player = document.createElement('div');
      player.className = 'pruvit-media__player';
      player.appendChild(template.content.cloneNode(true));
      template.remove();
    } else if (embed) {
      player = document.createElement('iframe');
      player.src = embed;
      player.title = button.getAttribute('aria-label') || '';
      player.allow = 'autoplay; fullscreen';
      player.allowFullscreen = true;
      player.className = 'pruvit-media__player';
    } else {
      return;
    }

    wrapper.replaceChild(player, button);

    // The click landed on a button that no longer exists, so focus would fall
    // back to <body> and a keyboard user would lose their place entirely.
    var focusable = player.querySelector('video') || player;
    focusable.setAttribute('tabindex', '-1');
    focusable.focus({ preventScroll: true });
  });
})();
